import React, { useState, useEffect } from "react";
import BreadCrumb from "../components/BreadCrumb";
import { Link } from "react-router-dom";

import packageJson from "../../package.json";

const BASE_URL = packageJson.apiUrl;

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/faq`);
        const data = await response.json();
        console.log("Fetched FAQ data:", data);
        if (data.success && Array.isArray(data.data)) {
          setFaqData(data.data);
        }
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    };

    fetchFaqData();
  }, []); // Runs only once on component mount

  return (
    <>
      <BreadCrumb />
      <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 my-auto">
              <div className="main-h text-start">
                <h1 className="m-heading text-start">Help & Faq</h1>
              </div>

              {/* FAQ Section */}
              <div className="cr-card">
                <div className="cr-card-head">
                  <h3 className="cr-title">Frequently Asked Questions​​</h3>
                </div>
                <div className="cr-card-body">
                  <div className="accordion" id="accordionExample">
                    {faqData.length > 0 ? (
                      faqData.map((faq, index) => (
                        <div className="accordion-item" key={faq.faq_id}>
                          <h2 className="accordion-header" id={`heading${faq.faq_id}`}>
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${faq.faq_id}`}
                              aria-expanded={activeIndex === index ? "true" : "false"}
                              aria-controls={`collapse${faq.id}`}
                              onClick={() => setActiveIndex(index)}
                            >
                              {faq.question}
                            </button>
                          </h2>
                          <div
                            id={`collapse${faq.faq_id}`}
                            className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}
                            aria-labelledby={`heading${faq.faq_id}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p>{faq.answer}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>Loading FAQs...</p>
                    )}
                  </div>
                </div>
              </div>
              {/* End of FAQ Section */}

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
